import React, {Component} from "react";
import OitRatingStatistics from "../analytics/OitRatingStatistics";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import Checkbox from "../../../shared/forms/Checkbox";
import Modal from "../../../shared/ui/Modal";

class DashboardStatisticsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOitGuids: [],
      isLoading: true,
      questionsSet: false,
      reportAnalytics: [],
      selectedQuestions: [],
      selectedPhasesMap: {},
      selectedFormTypes: props.departmentSettings.oitStatisticsFormTypes || ['dor', 'dor2', 'dor3', 'dor3', 'rdor', 'dorr'],
      showFormTypeModal: false

    }
  }

  componentDidMount() {
    if(this.props.forms && !this.state.questionsSet) {
      this.setState({
        selectedQuestions: this.addQuestionsToFilter(this.currentQuestions),
        questionsSet: true
      })
    }
    this.setSelectedOit(this.props.oitGuid)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.forms && !this.state.questionsSet) {
      this.setState({
        selectedQuestions: this.addQuestionsToFilter(this.currentQuestions),
        questionsSet: true
      })
    }

    if(prevProps.oitGuid.length !== this.props.oitGuid.length) {
      this.setSelectedOit(this.props.oitGuid)
    }
  }

  get selectedOits() {
    return this.state.selectedOitGuids.map((oitGuid) => this.getOit(oitGuid))
  }

  get oitsInProgress() {
    return this.props.oits

  }

  getOit(oitGuid) {
    return this.oitsInProgress.find(oit => oit.guid === oitGuid)
  }

  setSelectedOit(oitGuids) {


    let oit = this.getOit(oitGuids[0]);

    if(!this.state.selectedOitGuids.length) {
      this.setState({
        selectedPhasesMap: oit.trainingPhases
          .filter(tp => tp.type !== 'orientation')
          .reduce((acc, tp) => ({
            ...acc,
            [tp.sequence]: true
          }), {}),
        trainingPhases: oit.trainingPhases
      })
    }

    this.setState({
      selectedOitGuids: oitGuids,
      isLoading: true
    });
  }

  addQuestionsToFilter(questions) {
    return Object.assign(questions.reduce((acc, question) => ({
      ...acc,
      [question.id]: true
    }), {}), this.state.selectedQuestions)
  }

  handleFormTypeClick() {
    this.setState({
      showFormTypeModal: true
    });
  }

  closeFormTypeModal(e) {
    this.setState({
      showFormTypeModal: false
    });
  }

  get critiqueFormTypes() {
    return this.props.departmentSettings && this.props.departmentSettings.critiqueFormTypes ? this.props.departmentSettings.critiqueFormTypes : ['ftc'];
  }

  get currentForms() {
    if(!this.props.forms) {
      return []
    }

    return this.props.forms
      .filter(f => f.status === 'current')
      .filter(f => {
        if (this.critiqueFormTypes.includes(f.type)) {
          return this.props.canViewCritiqueForms;
        }
        return true
      })
  }

  get currentQuestions() {
    return this.currentForms
      .filter(f => this.isFormTypeChecked(f))
      .reduce((acc, form) => {
        return [
          ...acc,
          ...form.layout.filter(q => q.type === 'question' && (q.schema.startsWith('rating') || q.schema === 'pto-rating-multi'))
        ]
      }, [])
  }

  get filteredQuestions() {
    return this.currentQuestions.filter(q => this.state.selectedQuestions[q.id])
      .reduce((acc, q) => ({
        ...acc,
        [q.id]: q
      }), {})
  }

  isFormTypeChecked(form) {
    return this.state.selectedFormTypes.includes(form.type)
  }

  onFormTypeSelectChange(checked, form) {
    let selectedFormTypes = [...this.state.selectedFormTypes];
    if(checked) {
      selectedFormTypes = [...selectedFormTypes.filter(f => f !== form.type), form.type];
    } else {
      selectedFormTypes = selectedFormTypes.filter(f => f !== form.type);
    }

    this.setState({
      selectedFormTypes
    })
  }

  render() {
    return (
      <div className="dashboard-statistics-report">
        {this.selectedOits.length && !!Object.keys(this.filteredQuestions).length && !this.isLoading && (
          <div>
            <div className="mr-2">
              <button className="button secondary" onClick={() => this.handleFormTypeClick()}>
                <i className="fa fa-paperclip"/>
                Form types
              </button>
            </div>
            <div className="selected-users">
              <br/>
              <div style={{display: 'flex', flexWrap: 'wrap'}}>
                {this.state.trainingPhases
                  .filter(tp => tp.type !== 'orientation')
                  .map(tp => (
                    <div key={tp.sequence} style={{marginRight: '10px'}}>
                      <Checkbox
                        label={tp.header}
                        checked={this.state.selectedPhasesMap[tp.sequence]}
                        onChange={e => this.setState({selectedPhasesMap: {...this.state.selectedPhasesMap, [tp.sequence]: e.target.checked}})}
                      />
                    </div>
                  ))}
              </div>
            </div>
            <OitRatingStatistics
              oits={this.selectedOits}
              selectedQuestions={this.filteredQuestions}
              selectedPhasesMap={this.state.selectedPhasesMap}
              formTypes={this.state.selectedFormTypes}
              inline={true}
            />
          </div>)}

        <Modal
          fullscreen={true}
          title="Choose form types to display"
          isOpen={this.state.showFormTypeModal}
          onClose={(e) => this.closeFormTypeModal(e)}
          size="sm"
        >
          <div className="p-3">
            {this.currentForms.map(form => (
              <Checkbox
                key={form.type}
                checked={this.isFormTypeChecked(form)}
                label={form.name}
                onChange={(e) => {
                  this.onFormTypeSelectChange(e.target.checked, form)
                }}
              />
            ))}
            <div>
              <button className="button primary mt-3" onClick={() => this.closeFormTypeModal()}>
                Apply changes
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    viewingReport: state.reports.viewingReport,
    departmentSettings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    forms: state.forms.list,
    userContext: state.common.userContext
  };
}
export default connect(mapStateToProps)(DashboardStatisticsReport)
